var BrowserFS = require('browserfs');module.exports=BrowserFS.BFSRequire('process');



/*****************
 ** WEBPACK FOOTER
 ** ./shims/process.js
 ** module id = 3
 ** module chunks = 0
 **/